module.exports = __webpack_public_path__ + "static/media/firewall2.35ede179.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/firewall2.svg
// module id = 359
// module chunks = 0